import React from 'react';
import { ToggleButton, ToggleButtonGroup,Box, Typography, Stack  } from '@mui/material';

type GraphType = 'follicular' | 'hormonal';
type OvarySide = 'left' | 'right';

interface GraphHeaderProps {
  graphType: GraphType;
  setGraphType: (val: GraphType) => void;
  selectedSide: OvarySide;
  setSelectedSide?: (val: OvarySide) => void;
}

const GraphHeader: React.FC<GraphHeaderProps> = ({
  graphType,
  setGraphType,
  selectedSide,
})  => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
      {/* Graph Type Switch */}
      <ToggleButtonGroup
        value={graphType}
        exclusive
        onChange={(_, value) => value && setGraphType(value)}
        sx={{
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontWeight: 600,
            border: '1px solid #eee',
            borderRadius: '12px',
            px: 2,
            color: '#888',
            marginRight:'16px !important'
          },
          '& .Mui-selected': {
            borderColor: '#E17E61 !important',
            color: '#E17E61 !important',
            backgroundColor: 'rgba(225, 126, 97, 0.1) !important'
          }
        }}
        
      >
        <ToggleButton value="follicular">Follicular Graph</ToggleButton>
        <ToggleButton value="hormonal">Hormonal Graph</ToggleButton>
      </ToggleButtonGroup>

      {/* Ovary Side Selector */}
      {graphType==='follicular' && <Stack direction="row" spacing={2} alignItems="center">
        {['left', 'right'].map((side) => (
          <Stack key={side} direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: selectedSide === side
                  ? (side === 'left' ? '#d4d3dd' : '#474a57')
                  : '#e0e0e0', // Faded or neutral background for unselected
                transition: 'background-color 0.3s ease',
                opacity: selectedSide === side ? 1 : 0.3
              }}
            />
            <Typography
              variant="body2"
              fontWeight={selectedSide === side ? 600 : 400}
              color={selectedSide === side ? '#000' : '#666'}
            >
              {side.charAt(0).toUpperCase() + side.slice(1)}
            </Typography>
          </Stack>
        ))}
      </Stack>}
    </Box>
  );
};

export default GraphHeader;
